import { usePartner } from '@/context/PartnerContext'
import { Box, HStack, Image, Stack } from '@chakra-ui/react'
import type { ReactNode } from 'react'

export const EmailPageLayout = ({ children, elementRight }: { children: ReactNode, elementRight?: ReactNode }) => {
  const { currentPartner } = usePartner()
  return <Stack w="full" p={4} justifyContent='center' alignItems='center'  bg='white' minH="100dvh">
    <Stack justifyContent='center' alignItems='center' maxW='3xl'>
      <HStack justifyContent='space-between' w={elementRight ? 'full' : 'auto'}>
        <Box sx={{
          pt: { base: 4, md: 8 },
          pb: { base: 8, md: 12 },
        }}>
          <Image
            src={currentPartner?.logo}
            alt=""
            sx={{
              w: 'full',
              maxW: 'xs',
              h: 'full',
              maxH: 12
            }}
          />
        </Box>
        {elementRight}
      </HStack>
      <Stack
        gap={{ base: 8, md: 12 }}
        w="full"
        justifyItems='center'
      >
        {children}

      </Stack>
    </Stack>
  </Stack>
}